module.exports = __webpack_public_path__ + "static/media/Engineering-e-Logistic.5deddbae.png";